import { type ScreenType, useScreenType } from './use-screen-type.ts'

export type UiContext = ScreenType | 'backoffice'

export function useUiContext(): UiContext {
  const screenType = useScreenType()

  const firstUrlSlot = window.location.pathname.split('/')[1]

  if (firstUrlSlot === 'bo' || firstUrlSlot === 'partner') return 'backoffice'

  return screenType
}
